import React, { useEffect, useState } from 'react';
import { layouts } from 'seal-ui-components';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Drawer } from '@Components/Drawer';
import { ScoreCardItemDetails } from '../ScoreCardItemDetails';
import { SuggestedClauseTitle, SearchBoxWrapper } from './ScorecardDetails.style';
import { ClauseTree as ClauseTreeList } from '../../../ClauseTree/components/Tree';
import ClauseTreeSearch from '../../../ClauseTree/ClauseTreeSearch';
import { ClauseList } from '../../../ClauseTree/components/List';
import { NotFoundContainer } from '../../../ClauseTree/ClauseTree.style';

const BUFFER_HEIGHT = 50;

export const ScoreCardDetails = ({ data, isOpen, onClose }) => {
    const [searchResults, setSearchResults] = useState([]);
    const [noResults, setNoResult] = useState(false);
    const [treeSearchHeight, setTreeSearchHeight] = useState(0);
    const [scoreCardHeight, setScoreCardHeight] = useState(0);

    const flattenClauseGroups = useSelector(state => state.clause.flattenClauseGroups);

    const {
        riskColor,
        riskLevel,
        answerField,
        question,
        topic,
        subtopic,
        suggestedClauseGroupsMap
    } = data;

    const suggestedClauses = Object.values(suggestedClauseGroupsMap || {});

    const setSuggestClausesSearch = React.useCallback(
        searchResult => {
            let suggestedClausesSearchResult = searchResult.filter(
                clauseId => suggestedClauses.findIndex(clause => clause.id == clauseId) > -1
            );
            if (suggestedClausesSearchResult.length || !searchResult.length) {
                setNoResult(false);
            } else {
                setNoResult(true);
            }

            setSearchResults(suggestedClausesSearchResult);
        },
        [Object.values(suggestedClauseGroupsMap || {}).length, isOpen]
    );

    useEffect(
        () => {
            if (!isOpen) {
                setSearchResults([]);
                setNoResult(false);
            }
        },
        [isOpen]
    );

    return (
        <Drawer
            dir={'right'}
            isOpen={isOpen}
            close={onClose}
            contentStyle={{ overflowX: 'hidden' }}
        >
            <ScoreCardItemDetails
                {...{
                    riskColor,
                    riskLevel,
                    answerField,
                    question,
                    topic,
                    subtopic
                }}
                onSize={size => setScoreCardHeight(size.height)}
                data-testid="scorecard-item"
            />

            <layouts.HorizontalBox
                style={{ justifyContent: 'space-between', marginBottom: '10px' }}
            >
                <SuggestedClauseTitle data-testid="suggest-title">
                    Suggested clauses
                </SuggestedClauseTitle>
                <Link to="/clauses" data-testid="clause-link">
                    Clause library
                </Link>
            </layouts.HorizontalBox>

            <SearchBoxWrapper data-testid="search-box">
                <ClauseTreeSearch
                    setSearchResults={setSuggestClausesSearch}
                    noExpandable
                    onSize={size => setTreeSearchHeight(size.height)}
                />

                {noResults && <NotFoundContainer>No matching results</NotFoundContainer>}
            </SearchBoxWrapper>

            {searchResults.length ? (
                <ClauseList
                    flattenClauseGroups={flattenClauseGroups}
                    searchResults={searchResults}
                    headerHeight={treeSearchHeight + scoreCardHeight + BUFFER_HEIGHT}
                />
            ) : (
                <ClauseTreeList
                    data={suggestedClauses}
                    flattenClauseGroups={flattenClauseGroups}
                    noIndentation
                />
            )}
        </Drawer>
    );
};
